import React, { createContext, useState } from 'react';
// import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
// import Pool from './UserPool';
import { signIn, signOut, fetchAuthSession } from 'aws-amplify/auth'
import { useNavigate } from 'react-router-dom'

const AccountContext = createContext();

const Account = props => {
    const [email, setEmail] = useState(null);
    const navigate = useNavigate();

    const getSession = async () => {
        const {
            tokens,
            credentials,
            identityId,
            userSub
        } = await fetchAuthSession();
        const {
            idToken,
            accessToken
        } = tokens;

        const email = idToken.payload.email;
        setEmail(email);
    }


    const authenticate = async ({
        username,
        pwd
    }) => {
        await signIn({
            username: username,
            password: pwd
        });
    }

    const logout = async () => {
        await signOut().then(() => {
            navigate("/");
        });
    };

    return (
        <AccountContext.Provider value={{
            authenticate,
            getSession,
            logout,
            email
        }}>
            {props.children}
        </AccountContext.Provider>
    );
};

export { Account, AccountContext };
